import React from 'react';
import algoliasearch from 'algoliasearch/lite';
import {
  InstantSearch,
  Hits,
  SearchBox,
  ClearRefinements,
  RefinementList,
  Pagination,
  Highlight,
} from 'react-instantsearch-dom';
import NoResults from './widgets/NoResults.js';
import PropTypes from 'prop-types';
import './App.css';
import Footer from './footer'

const searchClient = algoliasearch(
	  'PVXAVYZ0PS',
	  'fef229629ce3f6df1099709a65f53569'
);
function App() {
  return (
    <div>
      <header className="header">
        <h1 className="header-title">
         
	  <img src="/images/logo_transparent.png" alt="logo" />
	   
        </h1>
    <p className="header-subtitle">
	 <a href="https://retrosynthesis-ai.gitbook.io/retrosynthesis-ai/">
	   Documentation
	   </a>
    </p>
	<p className="header-subtitle"> 
	  <a href="Drugs.html">
           Classifications
	  </a>
    </p>
	<p className="header-subtitle">
	 <a href="https://share.streamlit.io/retrosynthesisai/explore_app/main#visualization">
	   Explore
	   </a>
    </p>
	<p className="header-subtitle">
	 <a href="FAQ.html">
	   FAQs
	   </a>
    </p>
	<p className="header-subtitle">
	 <a href="resources.html">
	   Resources
	   </a>
    </p>
	<p className="header-subtitle"> 
	  <a href="Contact.html">
           Contact
	  </a>
        </p>
      </header>
      
     <p className="message1">
       <img src = "/images/new_logo3.png" alt="RAI Logo" class="center" />
	  <br />
  	    <h2>Rapidly explore retrosynthetic pathways linked to multiple pathways </h2>
		 
     </p> 

 <div className="container" >
        <InstantSearch searchClient={searchClient} indexName="main">
          <div className="search-panel" >
	  
            <div className="search-panel__filters"  >
			
	          <div className="clear-filters" data-layout="desktop">
                <ClearRefinements
                  translations={{
                    reset: (
                      <React.Fragment>
                       
                        Clear Filters
                      </React.Fragment>
                    ),
                  }}
                />
              </div>
			  
			  <p style={{color: '#3a4048'}}>Medication Classifications</p>
              <hr />
			  <RefinementList attribute="Med_Class" searchable={true} translations={{ placeholder: 'Search for Med Class',}}  />
			  <br /> 
		      <p style={{color: '#3a4048'}}>Drug Indications</p>
	           <hr />
	          <RefinementList attribute="Primary_Disease" searchable={true} translations={{ placeholder: 'Search for Drug Indications',}}  />
	          <br />
			  <p style={{color: '#3a4048'}}>Pathway Databases</p>
               <hr />
              <RefinementList attribute="Pathway_DB"  />
			    <br />
                <p style={{color: '#3a4048'}}>Dosage Forms</p>
                <hr />
			  <RefinementList attribute="Physical_Description"  />
			   <br />
                <p style={{color: '#3a4048'}}>CTD Pathways</p>
                <hr />
			  <RefinementList attribute="CTD_Pathway"  />
			    <br />		  
			    
			  <a href="https://algolia.com"><img src = "/images/algolia.png" alt="alg_logo" /></a><br />
			  <a href="https://www.netlify.com">
			  <img src="https://www.netlify.com/v3/img/components/netlify-color-accent.svg" alt="Deploys by Netlify" /></a>
		 
            </div>
         
            <div className="search-panel__results">
              <SearchBox
                className="searchbox"
                translations={{
                  placeholder: 'Search for Diseases, Drugs, Pathways and SMILES',
                }}
              />
           
   
            <div class="col-sm-3">
              <Hits hitComponent={Hit} />
			   <NoResults />
 </div>
 
              <div className="pagination">
                <Pagination />
              </div>
            </div>
          </div>
        </InstantSearch>
      </div>
	  <Footer/>
    </div>
  );
}

function Hit(props) {
  return (
    <article>
      <strong>Drug Name:</strong> &nbsp;
      <Highlight attribute="Drug_Name" hit={props.hit} />
      <p>
        <strong>Drug Indication:</strong> &nbsp;
        <Highlight attribute="Primary_Disease" hit={props.hit} />
      </p>
	   <p>
        <strong>Med Class:</strong> &nbsp;
        <Highlight attribute="Med_Class" hit={props.hit} />
      </p>
      <p>
        <strong>Alternative Indications:</strong> &nbsp;
        <Highlight attribute="Alternative_Disease" hit={props.hit} />
      </p>
      <p>
        <strong>Pathway:</strong> &nbsp;
        <Highlight attribute="Targeted_Pathway" hit={props.hit} />
      </p>
      <p>
        <strong>SMILES:</strong> &nbsp;
        <Highlight attribute="SMILES" hit={props.hit} />
      </p>
      <p>
        <strong>Retrosynthetic Pathway:</strong> &nbsp;
        <Highlight attribute="Retrosynthetic_Pathway" hit={props.hit} />
      </p>
      <p>
        <strong>Pathway Database:</strong> &nbsp;
        <Highlight attribute="Pathway_DB" hit={props.hit} />
      </p>
	  <p>
        <strong>Dosage Form:</strong> &nbsp;
        <Highlight attribute="Physical_Description" hit={props.hit} />
      </p>
      <p>
        <strong>CTD Pathways:</strong> &nbsp;
        <Highlight attribute="CTD_Pathway" hit={props.hit} />
      </p>
    </article>
  );
}

Hit.propTypes = {
  hit: PropTypes.object.isRequired,
};

export default App;
	
 
   
